import {createLogicMiddleware} from 'redux-logic';

import logic from '../logics/index';
import logicDep from './logicDep';

export default createLogicMiddleware(logic, logicDep);
